export const baseZIndex = {
  layout: {
    docsTableHeader: 900,
    notificationHeader: 920,
    header: 1000,
    leftSideBar: 1010,
    naviItemTooltip: 1020,
    contactAutoCompletePopover: 1030,
  },
  commonComponents: {
    segment: 20,
  },
  myDocument: {
    addSignerButton: 10,
    eSignContactDialogAddSection: 910,
  },
} as const;
